module.exports = __webpack_public_path__ + "img/18.4c690e54.jpg";